export default {
  type: 'affiliationTypes',
  name: 'Affiliation Type',
  newButton: false,
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_fy_users' },
    update: { app: 'metrics_dash', role: 'metrics_fy_users' },
    delete: { app: 'metrics_dash', role: 'metrics_fy_users_delete' }
  },
  search: {
    search: 'allAffiliationTypes',
    orderBy: {
      type: 'AffiliationTypesOrderBy',
      default: 'AFFILIATION_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        searchOnly: true
      },
      {
        name: 'affiliation',
        order: 'AFFILIATION',
        searchable: false
      },
      {
        name: 'typeOfBusiness',
        order: 'TYPE_OF_BUSINESS',
        searchable: false
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'affiliation',
        required: true
      },
      'typeOfBusiness'
    ],
    key: ['affiliation'],
    input: 'affiliationType',
    create: 'createAffiliationType',
    delete: 'deleteAffiliationType',
    update: 'updateAffiliationType'
  },
  load: {
    nodeId: 'affiliationType',
    key: 'affiliationTypeByAffiliation'
  },
  form: {
    print: false,
    schema: [
      {
        name: 'affiliation',
        required: true
      },
      {
        name: 'typeOfBusiness'
      }
    ]
  }
}
